<template>
  <div class="block-content-container" :style="containerStyle">
    <div class="block-content-inner">
      <div class="title-box" :style="{color: eleConfig.otherConfig.titleColor || '#333'}">{{ $dt(eleConfig, 'title') }}</div>
      <!--      {{eleConfig.gap}}-->
      <a-row :gutter="[eleConfig.gap || 24, eleConfig.gap || 24]">
        <a-col v-for="item in eleConfig.dataList" :key="item._id" :span="24/(eleConfig.otherConfig.columnCount || 3)">
          <div :style="itemStyle">
            <div class="block-title" :style="{color: eleConfig.otherConfig.blockTextColor || '#333'}">{{ $dt(item, 'title') }}</div>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script>
import componentMixin from './componentMixin';

export default {
  name: "blockArr",
  mixins: [componentMixin],
  computed: {
    containerStyle() {
      const style = {};
      if (this.eleConfig.backgroundImage) {
        const imgPath = this.$Dolphin.path.publicPath + this.eleConfig.backgroundImage.filePath;
        style.backgroundImage = `url(${imgPath})`;
      } else {
        style.backgroundColor = this.eleConfig.backgroundColor || '#ffffff';
      }
      return style;
    },
    itemStyle() {
      const style = { height: '100%' };
      const otherConfig = this.eleConfig.otherConfig;
      style.padding = this.getNumber(otherConfig.newsPadding, 24) + 'px';
      style.borderRadius = this.getNumber(otherConfig.blockBorderRadius, 0) + 'px';
      style.backgroundColor = otherConfig.blockBgColor || '#FFFFFF';
      return style;
    },
  },
}
</script>

<style scoped lang="scss">
.block-content-container {
  width: 100%;
  padding: 96px 0;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .block-content-inner {
    width: 1280px;
    margin: 0 auto;
  }

  .title-box {
    font-size: 32px;
    line-height: 45px;
    font-weight: 600;
    margin-bottom: 24px;
  }

  .block-title {
    font-size: 24px;
    line-height: 33px;
    font-weight: 600;
    text-align: center;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

</style>
